// Initiate Animate on Scroll
  AOS.init();


// Home Hero Swiper
const homeHeroSwiper = new Swiper('.home-hero-slider .swiper', {
  autoplay: {
    delay: 5000,
  },
  loop: true,
  pagination: {
    el: '.swiper-pagination',
    clickable: true
  },
});

// Brand Swiper
const brandSwiper = new Swiper('.tbx-brand-slider .swiper', {
  slidesPerView: 1,
  spaceBetween: 20,
  pagination: {
    el: ".swiper-nav-pagination",
    type: "fraction",
  },
  navigation: {
    nextEl: '.swiper-nav-next',
    prevEl: '.swiper-nav-prev',
  },
  breakpoints: {
    576: {
      slidesPerView: 2,
    },
    998: {
      slidesPerView: 3,
    },
    2000: {
      slidesPerView: 4,
    }
  }
});

// Product Swiper
const productSwiper = new Swiper('.tbx-product-slider .swiper', {
  slidesPerView: 1,
  autoHeight: true,
  effect: 'fade',
  fadeEffect: { crossFade: true },
  spaceBetween: 20,
  pagination: {
    el: ".swiper-nav-pagination",
    type: "fraction",
  },
  navigation: {
    nextEl: '.swiper-nav-next',
    prevEl: '.swiper-nav-prev',
  }

});


// Product Swiper 2
const productSwiper2 = new Swiper('.tbx-product-slider-2 .swiper', {
  slidesPerView: 1,
  spaceBetween: 30,
  centerMode: true,
  pagination: {
    el: ".swiper-product-nav-pagination",
    type: "fraction",
  },
  navigation: {
    nextEl: '.swiper-product-nav-next',
    prevEl: '.swiper-product-nav-prev',
  },
  breakpoints: {
    998: {
      slidesPerView: 2,
    }
  }
});

// Testimonial Swiper
const testimonialSwiper = new Swiper('.tbx-testimonial-slider .swiper', {
  slidesPerView: 1,
  autoHeight: true,
  mobileFirst: true,
  pagination: {
    el: ".swiper-testimonial-nav-pagination",
    type: "fraction",
  },
  navigation: {
    nextEl: '.swiper-testimonial-nav-next',
    prevEl: '.swiper-testimonial-nav-prev',
  },
  breakpoints: {
    1200: {
      autoHeight: false,
    }
  }
});

$( document ).ready(function() {
  //JQuery Goes Here

  // Video Popup Toggle
    $('.video-button').click(function() {
      let $videoSrcId = $(this).attr("data-video-src");
      let $videoH2 = $(this).attr("data-h2");
      let $videoH3 = $(this).attr("data-h3");
      let $videoDetails = $(this).attr("data-details");
      let $popupImage = $(this).attr("data-image");
      let $imageElement = $('.video-popup-player .image-overlay');
      $('.video-popup-player').addClass('active');
      if ($videoH2) {
        $('.video-popup-player .video-information').removeClass('hidden');
        $('.video-popup-player .video-wrapper').removeClass('no-information')
      }
      $('.video-popup-player video').attr('src', $videoSrcId);
      $('.video-popup-player video').get(0).play();
      $('.video-popup-player .image-overlay').css('background-image', "url('" + $popupImage + "')");
        if(($imageElement).css('background-image') == 'url("https://www.shadowhunterblinds.com/pages/undefined")' ||
         $popupImage == ""

        ) {
          ($imageElement).addClass('hidden');
        }
      $('.video-popup-player .video-information h2').html($videoH2);
      $('.video-popup-player .video-information h3').html($videoH3);
      $('.video-popup-player .video-information .details').html($videoDetails);
      
      $('body').css('overflow', 'hidden');
    })

    $('.video-popup-player .close-button').click(function() {
      $('.video-popup-player').removeClass('active');
      setTimeout(function() { $('.video-popup-player .video-information').addClass('hidden'); }, 500);
      setTimeout(function() { $('.video-popup-player .video-wrapper').addClass('no-information'); }, 500);
      setTimeout(function() { $('.video-popup-player video').attr('src', "#"); }, 500);
      $('body').css('overflow', 'visible');
      $('.video-popup-player .image-overlay').removeClass('hidden');
      $('.video-popup-player video').get(0).stop();
    })

  // Dropdown Content Toggle
    $('.tbx-dropdown-content .tab').click(function() {
      $('.tbx-dropdown-content .tab').removeClass('active');
      $('.tbx-dropdown-content .content').removeClass('active');
      $currentId = $(this).attr('id');
      console.log($currentId);
      $(this).addClass('active');
      $('.tbx-dropdown-content #content-' + $currentId).addClass('active');
    })

    // End JQuery
});
